import type { EnhanceRequestBody } from "@nlc/shared-types";
import type { WretchResponse } from "wretch";

import apiClient from "@/lib/api/client";

export async function createOutputEnhancement(
  data: EnhanceRequestBody,
  abortController: AbortController,
): Promise<WretchResponse> {
  return apiClient
    .url("/requests/enhance")
    .signal(abortController)
    .post(data)
    .res();
}
